import * as React from 'react';
import AddUserForm from './../Layout/Form/AddUserForm';
import * as UserModule from 'Modules/UserModule';
import { News } from 'Redux/Actions/Models/ErrorActionModel';
import { setNewsForMoment } from 'Redux/Actions/ErrorActions';
import { connect } from 'react-redux';
import { withTranslation  } from 'react-i18next';
import {getVoivodeships} from "Redux/Actions/UserActions";

type Props = {
    history?: any;
};

type ConnectedDispatch = {
    createNewUser: Function;
    setNews: (news: News) => Function;
    clearStatus: () => Function;
    getVoivodeships: () => Promise<void>;
};

type ConnectedProps = {
    t: Function;
    userStore: UserModule.Types.UserStore;
};

type State = {};

class UserManagementAdd extends React.Component<Props & ConnectedProps & ConnectedDispatch, State> {
    constructor(props: Props & ConnectedProps & ConnectedDispatch) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    public async componentDidMount() {
      this.props.getVoivodeships()
    }

  public async handleSubmit({ provinces, counties, ...formData}: any) {
    const { createNewUser } = this.props;
    const mappedProvinces = formData?.roleName?.value == UserModule.UserEnumTypes.RoleName.TECHNICIAN
      ? provinces.map(({ value }) => value)
      : undefined

    const mappedCounties = formData?.roleName?.value == UserModule.UserEnumTypes.RoleName.TECHNICIAN
      ? counties.map(({ value }) => value)
      : undefined
    await createNewUser({ ...formData, provinces: mappedProvinces, countyIds: mappedCounties });
  }
    public render() {
        return (
            <div className="main__content main__content--scroll">
                <AddUserForm
                    onSubmit={this.handleSubmit}
                    {...{
                        typeForm: 'add'
                    }}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        userStore: state.userStore
    };
}

function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        createNewUser: (formData: UserModule.Types.CreateUserAccountForm) => dispatch(UserModule.Actions.createUser(formData)),
        clearStatus: () => dispatch(UserModule.Actions.clearCreateUserStatus()),
        setNews: (news: News) => dispatch(setNewsForMoment(news)),
        getVoivodeships: () => dispatch(getVoivodeships()),
    };
}

export default withTranslation (['forms', 'errors', 'dictionary'])(connect(
    mapStateToProps,
    mapDispatchToProps
)(UserManagementAdd) as React.ComponentClass<any>);



// WEBPACK FOOTER //
// ./src/components/UserManagement/UserManagementAdd.tsx